export default __webpack_public_path__ + "assets/assistLogoBlack.svg";